import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import {
  ADD_DISTRIBUTIONCENTERS,
  GET_DISTRIBUTIONCENTERS,
  DELETE_DISTRIBUTIONCENTERS,
  UPDATE_DISTRIBUTIONCENTERS,
  GET_DISTRIBUTIONCENTERSLIST,
} from '../../../Types'
import { useEffect } from 'react'

export const addDistributionCenters =
  (formValues) => async (dispatch, getState) => {
    dispatch(showLoading())
    await axios
      .post('api/DistCenter', formValues)
      .then(({ data }) => {
        formValues.id = data.response
        formValues.principalName = getState().Principals?.find(
          (x) => x.id === formValues.principalId
        )?.principalName
        dispatch({
          type: ADD_DISTRIBUTIONCENTERS,
          payload: formValues,
        })
        dispatch(hideLoading())
        toast.success('Record added successfully')
      })
      .catch(function (error) {
        dispatch(hideLoading())
        if (error.response) {
          if (error.response.status === 401) {
            logout()
            history.push('/login')
            history.go('/login')
          } else if (
            error.response.status === 400 &&
            error.response.data.errors
          ) {
            let errorMessage = ''
            var errors = error.response.data.errors
            var keys = Object.keys(errors)
            for (let j = 0; j < keys.length; j++) {
              errorMessage += errors[keys[j]] + ' , \n'
            }
            toast.error(errorMessage)
          } else if (error.response.data)
            toast.error(
              error.response.data.Message
                ? error.response.data.Message
                : error.response.data.message
            )
          else {
            toast.error('Error while processing the request')
          }
        } else toast.error('Error while processing the request')
      })
  }

export const getDistributionCenters = (id) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .get(`api/DistCenter/${id}`)
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: GET_DISTRIBUTIONCENTERS,
        payload: data,
      })
      dispatch(hideLoading())
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.status === 400 && error.response.data.errors) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const updateDistributionCenters =
  (id, formValues) => async (dispatch, getState) => {
    dispatch(showLoading())
    await axios
      .put(`api/DistCenter/${id}`, formValues)
      .then(({ data }) => {
        formValues.principalName = getState().Principals?.find(
          (x) => x.id === formValues.principalId
        )?.principalName
        dispatch({
          type: UPDATE_DISTRIBUTIONCENTERS,
          payload: formValues,
        })
        dispatch(hideLoading())
        toast.success('Record updated successfully')
      })
      .catch(function (error) {
        dispatch(hideLoading())
        if (error.response) {
          if (error.response.status === 401) {
            logout()
            history.push('/login')
            history.go('/login')
          } else if (
            error.response.status === 400 &&
            error.response.data.errors
          ) {
            let errorMessage = ''
            var errors = error.response.data.errors
            var keys = Object.keys(errors)
            for (let j = 0; j < keys.length; j++) {
              errorMessage += errors[keys[j]] + ' , \n'
            }
            toast.error(errorMessage)
          } else if (error.response.data)
            toast.error(
              error.response.data.Message
                ? error.response.data.Message
                : error.response.data.message
            )
          else {
            toast.error('Error while processing the request')
          }
        } else toast.error('Error while processing the request')
      })
  }

export const deleteDistributionCenters = (id) => async (dispatch) => {
  if (!id) return
  dispatch(showLoading())
  await axios
    .delete(`api/DistCenter/${id}`)
    .then(() => {
      dispatch({ type: DELETE_DISTRIBUTIONCENTERS, payload: id })
      dispatch(hideLoading())
      toast.success('Record deleted successfully')
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          history.push('/login')
          history.go('/login')
        } else if (error.response.status === 400 && error.response.data.errors) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const getDistributionCentersList =
  (distributorId) => async (dispatch) => {
    dispatch(showLoading())
    await axios
      .get(
        `api/DistCenter/GetDistributionCentersByDistributor/${distributorId}`
      )
      .then(({ data }) => {
        dispatch({
          type: GET_DISTRIBUTIONCENTERSLIST,
          payload: data,
        })
        dispatch(hideLoading())
      })
      .catch(function (error) {
        dispatch(hideLoading())
        if (error.response) {
          if (error.response.status === 401) {
            logout()
            history.push('/login')
            history.go('/login')
          } else if (
            error.response.status === 400 &&
            error.response.data.errors
          ) {
            let errorMessage = ''
            var errors = error.response.data.errors
            var keys = Object.keys(errors)
            for (let j = 0; j < keys.length; j++) {
              errorMessage += errors[keys[j]] + ' , \n'
            }
            toast.error(errorMessage)
          } else if (error.response.data)
            toast.error(
              error.response.data.Message
                ? error.response.data.Message
                : error.response.data.message
            )
          else {
            toast.error('Error while processing the request')
          }
        } else toast.error('Error while processing the request')
      })
  }
